module.exports = __webpack_public_path__ + "media/images/features/perfecting_collaboration_img-25dc385e79238300fd99e11ce3968843.png";